module.exports = __webpack_public_path__ + "img/logoMachina.3c4b583e.svg";